export default "__VITE_ASSET__Clcg5Mv4__"